import { coreUrls } from '@/api/urls/core';

import { formatStringByKey } from '@/utilities/formatStringByKey';
import { setApiOptions } from '@/utilities/services';

import { RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import {
    CategoryFilterAttribute,
    CategoryShippingCostType,
    CategoryTreeNode,
    CategoryType,
    GetCategoriesQueryParam,
    GetCategoryShippingCostQueryParam
} from '@/server/services/core/category/models';
import { AxiosPromise } from 'axios';

export const getCategoriesService = (queryParam?: GetCategoriesQueryParam): AxiosPromise<RequestResponseType<CategoryType[]>> => {
    const options = setApiOptions(coreUrls.getCategories, queryParam ? { queryParam } : undefined, false);
    return api({ ...options, method: 'GET' });
};

export const getCategoryTreeService = (): AxiosPromise<RequestResponseType<CategoryTreeNode[]>> => {
    const options = setApiOptions(coreUrls.getCategoryTree, undefined, false);
    return api({ ...options, method: 'GET' });
};

export const getCategoryBySlugService = (slug: string): AxiosPromise<RequestResponseType<CategoryType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getCategoryBySlug, { slug }));
    return api({ ...options, method: 'GET' });
};

export const getCategoryShippingCostService = (
    categoryId: number,
    queryParam: GetCategoryShippingCostQueryParam
): AxiosPromise<RequestResponseType<CategoryShippingCostType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getCategoryShippingCost, { categoryId }), { queryParam });
    return api({ ...options, method: 'GET' });
};

export const getCategoryFiltersService = (categoryId: number): AxiosPromise<RequestResponseType<CategoryFilterAttribute[]>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getCategoryFilters, { id: categoryId }), undefined, false);
    return api({ ...options, method: 'GET' });
};
